const map = {
	"./ApiPage.jsx": [
		4425,
		[
			425
		]
	],
	"./MainPage.jsx": [
		3600,
		[]
	],
	"./MapPage.jsx": [
		7679,
		[
			962,
			712
		]
	],
	"./SettingsPage.jsx": [
		338,
		[]
	],
	"./UnderconstructionPage.jsx": [
		6609,
		[
			903,
			609
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8028;
module.exports = webpackAsyncContext;